const comments = [
  {
    id: 1,
    name: '影迷小王',
    time: '2小时前',
    rating: 5,
    content: '苹果视频真的太棒了！资源超全，画质也很清晰，重点是免费不缓冲。以前在西瓜视频免费看还要各种跳转，现在一个网站搞定所有，强烈推荐给所有爱看电影的朋友！',
    tag: '忠实用户',
  },
  {
    id: 2,
    name: '追剧达人Lucy',
    time: '5小时前',
    rating: 5,
    content: '追剧党福音！热播剧集更新超级快，跟各大平台同步。免费视频网站91的资源这边也有，不用到处找了。而且真的不卡，晚上高峰期看也流畅，太感动了。',
    tag: '追剧达人',
  },
  {
    id: 3,
    name: '老电影爱好者',
    time: '1天前',
    rating: 4,
    content: '作为一个老电影爱好者，能找到很多经典老片的资源真的不容易。苹果视频的经典重温专题做得特别好，分类清晰，画质修复得也不错。希望继续扩充经典片库！',
    tag: '资深影迷',
  },
  {
    id: 4,
    name: '程序猿小张',
    time: '2天前',
    rating: 5,
    content: '从技术角度说下，这个站的CDN加速做得不错，我家100M带宽看1080P完全无压力，拖进度条秒加载。UI设计也比很多同类站点清爽多了，没有乱七八糟的弹窗广告，体验满分。',
    tag: '技术控',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            听听用户们怎么说，数百万影迷的共同选择
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 transition-all duration-300 hover:scale-[1.01]"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="text-primary-600 text-sm font-bold">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                      <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                        {comment.tag}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                </div>
                <div className="flex items-center gap-0.5 text-accent-500 text-sm">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <div className="inline-flex items-center gap-6 px-6 py-4 rounded-2xl bg-background-100">
            <div className="text-center">
              <div className="text-xl font-bold text-foreground-900">4.8</div>
              <div className="text-xs text-foreground-400">综合评分</div>
            </div>
            <div className="w-px h-10 bg-secondary-200"></div>
            <div className="text-center">
              <div className="text-xl font-bold text-foreground-900">10万+</div>
              <div className="text-xs text-foreground-400">好评数量</div>
            </div>
            <div className="w-px h-10 bg-secondary-200"></div>
            <div className="text-center">
              <div className="text-xl font-bold text-foreground-900">98%</div>
              <div className="text-xs text-foreground-400">满意度</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}